import { ValidationResult } from '../forms/ValidationService';
import ajax from '../utils/ajax';

export interface AddMembershipResponse {
  isSuccessful: boolean;
  errorMessage?: string;
  redirectUrl?: string;
  validationResults?: ValidationResult[]
}

async function add(data: any): Promise<AddMembershipResponse> {
  return await ajax.post('/api/memberships/add', data) as AddMembershipResponse;
}

export default {
  add,
};
